



































































import Vue from "vue";
import { Tools } from "../../services";
import { CredentialValidationResponse } from "vue/types/vue";
import SignupMessageModal from "./SignupMessageModal.vue";

export default Vue.extend({
  components: {},
  data() {
    return {
      uname: "",
      pw: "",
      pwVerify: "",
      focused: "",
      modalMessage: "",
      modalHeader: "",
      showMessage: false
    };
  },
  props: {
    success: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showSignupMessage: {
      type: String,
      default: ""
    }
  },
  methods: {
    signup: async function(): Promise<void> {
      const pwvalidation: CredentialValidationResponse = Tools.passwordValidation(
        this.pw
      );
      const unamevalidation: CredentialValidationResponse = Tools.usernameValidation(
        this.uname
      );

      if (unamevalidation.invalid) {
        this.modalHeader = unamevalidation.header;
        this.modalMessage = unamevalidation.message;
        this.showMessage = true;
      } else if (pwvalidation.invalid) {
        this.modalHeader = pwvalidation.header;
        this.modalMessage = pwvalidation.message;
        this.showMessage = true;
      } else if (!(this.pw === this.pwVerify)) {
        this.modalHeader = "Ogiltigt lösenord";
        this.modalMessage = "Lösenorden matchar inte. Försök igen.";
        this.showMessage = true;
      } else {
        this.$emit("signup", { username: this.uname, password: this.pw });
      }
    },
    focus: function(input: string): void {
      this.focused = input;
    },
    closeMessage: function(): void {
      this.showMessage = false;
      this.modalMessage = "";
      this.modalHeader = "";
    },
    confirmSignup: function(): void {
      this.$emit("confirm", this.success);
    }
  }
});
